import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      select: 'Pick a subscription',
      select_2: 'Which subscription do you want to log in?',
      language: 'Language',
      login_failed_token_expired: 'Login timeout expired. Please login again!',
      login_failed_backend_error: 'Login failed',
      login_failed_under_upgrade: 'Your subscription is under maintenance. Please, try again later!.',
      login_failed_version_mismatch: 'Version mismatch',
      FORBID_BANNED_SUBSCRIPTION: 'Your subscription has banned. Please, contact support.',
      FORBID_DELETED_SUBSCRIPTION: 'Your subscription has deleted.'
    }
  },
  hu: {
    translation: {
      select: 'Válasszon egy előfizetést',
      select_2: 'Melyik előfizetésbe szeretne belépni?',
      language: 'Nyelv',
      login_failed_token_expired: 'Lejárt a bejelentkezési időkorlát. Kérjük jelentkezzen be újra!',
      login_failed_backend_error: 'Sikertelen bejelentkezés',
      login_failed_under_upgrade: 'Az Ön előfizetése frissítés alatt van. Kérjük, próbálja újra néhány perc múlva!',
      login_failed_version_mismatch: 'Nem megfelelő verzió!',
      FORBID_BANNED_SUBSCRIPTION: 'Az Ön előfizetése letiltásra került. Kérjük vegye fel a kapcsolatot az ügyfélszolgálattal.',
      FORBID_DELETED_SUBSCRIPTION: 'Az Ön előfizetése törlésre került.'
    }
  },
  fr: {
    translation: {
      select: 'Choisissez un abonnement',
      select_2: 'Quel abonnement souhaitez-vous souscrire?',
      language: 'Langue'
    }
  },
  de: {
    translation: {
      select: 'Wähle ein Abonnement',
      select_2: 'Welches Abonnement möchten Sie beitreten?',
      language: 'Sprache'
    }
  }
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    supportedLngs: ['en', 'hu', 'fr', 'de'],
    fallbackLng: 'hu'
  });

export default i18n;
